<template>
  <layout-apply-cancel @cancel="cancel" @apply="applyClick" />
</template>

<script>
/** (GW)
 * Asset Editor's text overlay apply cancel (top bar)
 * Emits apply event to parent assetEditorVue
 * Dispatches changeCurrentEffect
 */

import app from 'app';
import bus from 'v/AssetEditor/AssetEditorEventBus';
import LayoutApplyCancel from 'AssetEditor/layouts/LayoutApplyCancel.vue';
import { mapActions, mapMutations } from 'vuex';

export default {
  components: {
    LayoutApplyCancel,
  },

  data: function () {
    return {
      placeholder: null,
    };
  },

  methods: {
    ...mapMutations('assetEditor', ['setLastTextOverlayEffect']),
    ...mapActions('assetEditor', ['changeCurrentPage']),

    cancel: _.debounce(
      function () {
        this.setLastTextOverlayEffect(null);
        this.changeCurrentPage('preview');
      },
      app.TIME.MENTAL.λ,
      { leading: false, trailing: true }
    ),

    /**
     * Emit apply event
     * caught by assetEditor Vue's active child component
     */
    applyClick: function () {
      this.setLastTextOverlayEffect(null);
      bus.$emit('apply-click');
    },
  },
};
</script>
